import { GTM, GTM_EVENTS } from '../gtm/gtm-events'

const actions = {
  [GTM]: {
    [GTM_EVENTS.gtmEcomProductImpression]: ({ productData }) => {
      const viewmode = productData.viewmode === 'quickview' ? { viewmode: 'quickview' } : { viewmode: ' ' }
      return {
        ...viewmode,
        ecommerce: {
          currencyCode: productData.currency,
          impressions: productData.items,
        },
      }
    },
  },
}
export default actions
